import { makeObservable, observable, action, computed } from "mobx";
import { ModalState, waiting, ready, open, close } from "./Types";

class ModalStore {
  state: ModalState;

  constructor() {
    this.state = waiting();
    makeObservable(this, {
      state: observable,
      ready: action,
      open: action,
      close: action,
      isOpen: computed
    });
  }

  ready = () => {
    this.state = ready();
  };

  open = () => {
    this.state = open();
  };

  close = () => {
    this.state = close();
  };

  get isOpen() {
    switch (this.state.kind) {
      case "open":
        return true;
        break;
      case "waiting":
      case "close":
        return false;
        break;
      default:
        return false;
    }
  }
}

export default ModalStore;
